import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/* A full-width band with a parallax raw-denim background and a selvedge edge on the left. */
export default function DenimBand({ children, className = "", testid }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
    return (
        <section ref={ref} data-testid={testid} className={`relative overflow-hidden border-y border-white/10 ${className}`}>
            <motion.div
                aria-hidden="true"
                style={{ y, backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
                className="denim-bg absolute inset-x-0 -inset-y-[12%]"
            />
            <div className="absolute inset-0 bg-obsidian/75" aria-hidden="true" />
            <div
                aria-hidden="true"
                className="absolute inset-y-0 left-0 w-[3px] bg-gradient-to-b from-transparent via-[#b0402f] to-transparent opacity-80"
            />
            <div aria-hidden="true" className="absolute inset-y-0 left-[5px] w-px bg-white/25" />
            <div className="relative z-10">{children}</div>
        </section>
    );
}
